import BaseCard from './BaseCard';
import { CardType } from './CardType';

export default class KeyCard extends BaseCard {
    protected onCreate(params: any): void {
        params.cardFrontTexture = 'card_key';
        params.type = CardType.key;

        super.onCreate(params);
    }
}
